import { render } from "./GisDocumentDesigner.vue?vue&type=template&id=3d6a167c&ts=true"
import script from "./GisDocumentDesigner.vue?vue&type=script&lang=ts"
export * from "./GisDocumentDesigner.vue?vue&type=script&lang=ts"

import "./GisDocumentDesigner.vue?vue&type=style&index=0&id=3d6a167c&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__